import React, { useEffect, useState } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import { useNavigate } from "react-router-dom";
import { MdAddCircle } from "react-icons/md";
import toast from "react-hot-toast";
import { MdDownloadForOffline } from "react-icons/md";

import MoneyPurple from "../../Assets/Logos/MoneyPurple.png";
import MoneyGreen from "../../Assets/Logos/MoneyGreen.png";
import MoneyYellow from "../../Assets/Logos/MoneyYellow.png";
import MoneyRed from "../../Assets/Logos/MoneyRed.png";

import AddPayment_Form from "../../components/AdminSideComponents/AddPayment_Form";
import { FaFilter } from "react-icons/fa";
import { FaSearch, FaTimes } from "react-icons/fa";
import PaymentDetailsView from "../../components/AdminSideComponents/PaymentDetailsView";
import axios from "axios";
import DuesModal from "../../components/AdminSideComponents/DuesModal";
import exportToExcel from "../../utils/exportToExcel";
const Payments = () => {
  const [loading, setLoading] = useState(false);

  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentModal, setPaymentModal] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [buildings, setBuildings] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [checkInData, setCheckInData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState([]);
  const [loadPaymemtModal, setLoadPaymentModal] = useState(false);
  const [currentCheckIn, setCurrentCheckIn] = useState({});
  const [openDuesModal, setOpenDuesModal] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [rentCollectedInThisMonth, setRentCollectedInThisMonth] = useState(0);
  const [totalRent, setTotalRent] = useState(0);
  const [totalElectricityOfThisMonth, setTotalElectricityOfThisMonth] =
    useState(0);
  const [electricityCollectedInThisMonth, setElectricityCollectedInThisMonth] =
    useState(0);
  const navigate = useNavigate();

  const [allCheckIns, setAllCheckIns] = useState([]);
  const toggleDropdown = (index) => {
    setShowDropdown(showDropdown === index ? null : index);
  };

  //Function to fetch rent analytics
  const getRentAnalytics = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-rent-analytics`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getRentAnalytics: ", response.data);
        setRentCollectedInThisMonth(
          response.data.rentCollectedInThisMonth[0].total
        );
        setTotalRent(response.data.totalRentOfThisMonth[0].total);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Function to fetch the electricity analytics
  const getElectricityAnalytics = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-electricity-analytics`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getElectricityAnalytics: ", response.data);
        setElectricityCollectedInThisMonth(
          response.data.totalElectricityCollectedInThisMonth[0].total
        );
        setTotalElectricityOfThisMonth(
          response.data.totalElectricityOfThisMonth[0].total
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuildings(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchAllBuildings();
    getRentAnalytics();
    getElectricityAnalytics();
  }, []);
  const items = [
    {
      name: "Total Rent of This Month",
      numberOfItems: `Rs. ${totalRent}`,
      icon: MoneyPurple,
    },
    {
      name: "Rent Collected In This Month",
      numberOfItems: `Rs. ${rentCollectedInThisMonth}`,
      icon: MoneyGreen,
    },
    {
      name: "Total Electricity Bill Of This Month",
      numberOfItems: `Rs. ${totalElectricityOfThisMonth}`,
      icon: MoneyYellow,
    },
    {
      name: "Electricity Collected In This Month",
      numberOfItems: `Rs. ${electricityCollectedInThisMonth}`,
      icon: MoneyRed,
    },
  ];

  const current = new Date(); // Get the current date
  const currentYear = current.getFullYear(); // Get current year

  const rentCollectionDate = new Date(currentYear, current.getMonth(), 10); // Rent collection date for the 10th of the current month

  // useEffect(() => {
  //   // Calculate the grace period (5 days after rent collection date)
  //   const gracePeriodEnd = new Date(rentCollectionDate);
  //   gracePeriodEnd.setDate(gracePeriodEnd.getDate() + 5);
  //   console.log("i am grace period------->", gracePeriodEnd);
  //   // Check if the current date is within the allowed period
  //   if (current >= rentCollectionDate && current <= gracePeriodEnd) {
  //     setIsButtonDisabled(false); // Button active
  //   } else {
  //     setIsButtonDisabled(true); // Button disabled
  //   }
  // }, [current]);

  //Function to get all the check in data with their due details
  const getAllTenantCheckInData = () => {
    const tenantStatus = "Check In";
    setLoading(true);
    let data = "";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_check_in_paginated?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&tenantStatus=${tenantStatus}&hostelName=${selectedBuilding}&paymentStatus=${paymentStatus}`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setCheckInData(response?.data?.data);
        setPaginationInfo(response?.data?.pagination);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getAllCheckIns = async () => {
    try {
      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/check_in/get_all_check-in`,
      };

      const response = await axios.request(config);
      console.log("Response of getAllCheckIns: ", response.data);
      setAllCheckIns(response?.data?.data);

      return response?.data?.data; // Return data so caller can wait for it
    } catch (error) {
      console.error("Error in fetching all check-ins: ", error);
      return []; // Return empty array in case of error
    }
  };

  // console.log("Check-Ins: ", allCheckIns);

  useEffect(() => {
    getAllTenantCheckInData();
  }, [
    currentPage,
    searchTerm,
    selectedBuilding,
    paymentStatus,
    openDuesModal,
    loadPaymemtModal,
  ]);

  const handleDownloadClick = async () => {
    const checkIns = await getAllCheckIns();
    console.log("CheckIns: ", checkIns);
    if (checkIns?.length > 0) {
      const newTable = await checkIns?.map((data) => ({
        Name: data?.name,
        Contact: data?.mobile,
        "Joining Date": new Date(data?.joiningDate)?.toLocaleDateString(
          "en-GB",
          {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }
        ),
        "Building Name": data?.hostelName?.nameBuilding,
        "Room No": `R-F${data?.floorNo}${String(
          data?.roomId?.roomNumber
        ).padStart(3, "0")}`,
        "Bed No": data?.bedId?.bedNumber,
        "Total Dues": data?.amountOutstanding,
        Status: data?.paymentStatus,
      }));
      console.log("New table to be exported: ", newTable);

      if (newTable.length > 0) {
        exportToExcel(newTable, "Check-In Dues");
        console.log("Export completed: ");
      } else {
        console.error("❌ No valid data for export!");
        toast.error("No valid data to export");
      }
    } else {
      toast.error("No Data to export");
    }
  };

  // Navigate to the previous page
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Navigate to the next page
  const goToNextPage = () => {
    if (currentPage < paginationInfo.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  //Handling Collect button click
  const handleCollectButtonClick = (checkIn) => {
    // if (checkIn?.amountOutstanding === 0) {
    //   toast.success("Guest has already cleared all the dues");
    // } else {
    setLoadPaymentModal(true);
    setCurrentCheckIn(checkIn);
    // }
  };

  const togglefilterModal = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const clearSearch = () => {
    setSearchTerm("");
  };
  console.log(openDuesModal);
  console.log(currentCheckIn);
  return (
    <div className="checkinContainer p-6">
      <h1 className="text-[25px] sm:text-[26px] font-bold mb-6">Payments</h1>
      <Cards items={items} />
      {paymentModal ? (
        <AddPayment_Form setPaymentModal={setPaymentModal} />
      ) : (
        ""
      )}

      {loadPaymemtModal ? (
        <PaymentDetailsView
          setLoadPaymentModal={setLoadPaymentModal}
          currentCheckIn={currentCheckIn}
          getAllCheckIn={getAllTenantCheckInData}
        />
      ) : (
        ""
      )}

      {openDuesModal ? (
        <DuesModal
          setOpenDuesModal={setOpenDuesModal}
          currentCheckIn={currentCheckIn}
        />
      ) : (
        ""
      )}

      <div className="p-4 bg-[#FFFFFF] shadow-lg mt-6 rounded-lg ">
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-3 items-center">
            <h1 className="text-[18px] sm:text-[24px] font-bold ">
              Payments Lists
            </h1>

            <div className="relative inline-block">
              {/* Filter Button */}
              <button
                onClick={togglefilterModal}
                className="font-medium  flex items-center px-4 gap-2 py-2 bg-gray-200 shadow-xl rounded-md focus:outline-none"
              >
                <FaFilter size={20} className="text-primaryColor" />
                <span className="text-primaryTextColor">Filter</span>
                <svg
                  className="w-4 h-4 ml-2 text-secondaryTextColor"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div className="absolute right-0 w-48 z-50 p-4 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                  <p className="font-semibold text-primaryTextColor mb-2">
                    SORT BY :
                  </p>
                  <div className="space-y-2">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="All"
                        checked={paymentStatus === ""}
                        onChange={() => setPaymentStatus("")}
                        className="text-indigo-500 form-radio"
                      />
                      <span className="ml-2 text-primaryTextColor">All</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="Due"
                        checked={paymentStatus === "OverDue"}
                        onChange={() => setPaymentStatus("OverDue")}
                        className="text-indigo-500 form-radio"
                      />
                      <span className="ml-2 text-primaryTextColor">Due</span>
                    </label>

                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="Partial"
                        checked={paymentStatus === "Partial"}
                        onChange={() => setPaymentStatus("Partial")}
                        className="text-indigo-500 form-radio"
                      />
                      <span className="ml-2 text-primaryTextColor">
                        Partial
                      </span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        value="Cleared"
                        checked={paymentStatus === "Cleared"}
                        onChange={() => setPaymentStatus("Cleared")}
                        className="text-indigo-500 form-radio"
                      />
                      <span className="ml-2 text-primaryTextColor">
                        Cleared
                      </span>
                    </label>
                  </div>
                </div>
              )}
            </div>
            <select
              className="px-4 py-2 box-border text-[black]  bg-[#E5E7EB]  rounded-lg shadow-lg"
              onChange={(e) => setSelectedBuilding(e.target.value)}
            >
              <option value="">All Buildings</option>
              {buildings.map((b, index) => (
                <option key={index} value={b._id}>
                  {b.nameBuilding}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-gray-300 rounded-lg p-2 pl-8 pr-10 text-gray-700 focus:outline-none focus:ring focus:ring-blue-200"
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500" />
              {searchTerm && (
                <FaTimes
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                  onClick={clearSearch}
                />
              )}
            </div>
            <MdDownloadForOffline
              title="Download Data"
              onClick={handleDownloadClick}
              className="text-primaryColor  rounded-lg cursor-pointer"
              size={46}
              color="#2196f3"
            />
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-[85vw]   bg-white  border-gray-200 rounded-md">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Mobile Number
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Checked In
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Building Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Room No
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Bed No
                </th>

                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Total Dues
                </th>

                {/* <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Category
                </th> */}
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Status
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl ">
                  Collect Payment
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {loading ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))
              ) : checkInData?.length > 0 ? (
                checkInData.map((checkIn, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {checkIn?.name}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {checkIn?.mobile}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {checkIn?.joiningDate?.slice(0, 10)}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {checkIn?.hostelName?.nameBuilding}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      R-F{checkIn?.floorNo}
                      {String(checkIn?.roomId?.roomNumber).padStart(3, "0")}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {checkIn?.bedId?.bedNumber}
                    </td>

                    <td
                      className={`py-4 px-6 font-semibold text-sm  ${
                        checkIn?.amountOutstanding === 0
                          ? "text-green-500"
                          : "text-red-600"
                      }`}
                    >
                      Rs.{checkIn?.amountOutstanding}
                    </td>

                    <td className="py-4 px-6 text-sm ">
                      <span
                        className={`bg-${
                          checkIn?.paymentStatus === "Partial"
                            ? "yellow-100 text-yellow-700"
                            : checkIn?.paymentStatus === "OverDue"
                            ? "red-100 text-red-700"
                            : checkIn?.paymentStatus === "Cleared"
                            ? "green-100 text-green-700"
                            : ""
                        } px-4 py-2 text-lg tracking-wide rounded-lg cursor-pointer`}
                      >
                        {checkIn?.paymentStatus}
                      </span>{" "}
                    </td>
                    <td className="py-4 px-6 text-sm hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                      <div className="relative ">
                        <button
                          onClick={() => handleCollectButtonClick(checkIn)}
                          className={`px-4 py-2 bg-green-400 rounded-lg text-white font-semibold tracking-wide`}
                        >
                          {/* {isButtonDisabled ? "Coming Soon" : "Collect Now"} */}
                          Collect Now
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="py-40 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No CheckIn available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(
              itemsPerPage * currentPage,
              paginationInfo?.totalCheckIns
            )}{" "}
            of {paginationInfo?.totalCheckIns}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === paginationInfo.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === paginationInfo.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;
